// import components
import { styled, Box } from '@mui/material';

export const StyledUnrealizedDutyCountBox = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const StyledOpenedStatusBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'auto',
  width: '100%',
  padding: theme.spacing(4)
}));
